import * as aor from "react-admin";
import React from "react";
import CardActions from "@material-ui/core/CardActions";
import {
    POLICY_USERS,
    POLICY_NOTIFICATIONS
} from "../../common/rolesManagement";
import { getLoggedUserFromToken, getPolicies } from "../../common/authClient";
import { refreshView } from "react-admin";
import AddressLink from "../../components/AddressLink";
import { ArrayField } from "react-admin";
import it from "../../messages/it";

const LOGGED_USER = getLoggedUserFromToken();

const MyEditButton = ({ permissions, basePath, record }) => {
    if (permissions.includes(POLICY_USERS.SELF_UPDATE)) {
        if (record && LOGGED_USER === record.username) {
            return <aor.EditButton basePath={basePath} record={record} />;
        } else {
            return <span />;
        }
    } else {
        return <aor.EditButton basePath={basePath} record={record} />;
    }
};

const Actions = ({ basePath, data, permissions }) => (
    <CardActions style={{ zIndex: 2, display: "inline-block", float: "right" }}>
        <MyEditButton
            permissions={permissions}
            basePath={basePath}
            record={data}
        />
        <aor.ListButton basePath={basePath} />
    </CardActions>
);

const refresh = () => {
    refreshView();
};

const MyLicenceField = ({ data }) => (
    <div>
        {Object.keys(data).length > 0 ? (
            Object.keys(data).map(item => <li>{item.replace(/"/g, "")}</li>)
        ) : (
            <a>{it.missing_inst_types}</a>
        )}
    </div>
);
MyLicenceField.defaultProps = { addLabel: true };

export default props => (
    <aor.Show
        {...props}
        title={"resources.users.nameSingular"}
        actions={<Actions permissions={getPolicies()} />}
    >
        <aor.SimpleShowLayout {...props}>
            <AddressLink
                {...props}
                source="username"
                enabled={getPolicies().includes(
                    POLICY_NOTIFICATIONS.SEND_NOTIFICATIONS
                )}
            />
            <aor.TextField source="surname" />
            <aor.TextField source="name" />
            {getPolicies() &&
                !getPolicies().includes(POLICY_USERS.SELF_UPDATE) && (
                    <aor.ReferenceArrayField
                        reference="companies"
                        source="company_ids"
                    >
                        <aor.Datagrid>
                            <aor.TextField source="name" sortable={false} />
                            <aor.TextField source="vatin" sortable={false} />
                            <aor.TextField
                                source="seller_code"
                                sortable={false}
                            />
                            <aor.ShowButton />
                        </aor.Datagrid>
                    </aor.ReferenceArrayField>
                )}
            <ArrayField
                label="Può gestire installazioni:"
                source="installation_types_name"
            >
                <MyLicenceField></MyLicenceField>
            </ArrayField>
            {refresh()}
        </aor.SimpleShowLayout>
    </aor.Show>
);



// WEBPACK FOOTER //
// ./src/resources/Users/Show.js